"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dependencies_1 = require("./dependencies");
/** @description decreases lightness by a FIXED amount, functioning like scss darken (https://sass-lang.com/documentation/modules/color#darken)
 * To make a color a certain percentage lighter than it was before, use scaleLightness instead.
 *
 * @param {string} color Six digit hex code beginning with #. Examples: #ff0000, #FFFFFF, #b37399.
 * @param {number} amount Number between 0 and 100.
 * - Amount of 100 will always return black, #000000. Amount greater than 100 is functionally equivalent to 100.
 * - Amount below 0 will increase lightness by the fixed amount instead of decrease.
 * - Amount of -100 will always return white, #FFFFFF. Amount less than -100 is functionally equivalent to -100.
 *
 * @return {string} Six digit hex code beginning with #. Examples: #ff0000, #FFFFFF, #b37399.
 */
function darken(color, amount) {
    return new dependencies_1.TinyColor(color).darken(amount).toHexString();
}
exports.default = darken;
//# sourceMappingURL=Darken.js.map